<section>
  <app-form-header [menuDefinition]="menuDefinition" (onSave)="onSubmit()" (onCancel)="cancel()"></app-form-header>
  @if (!moduleActive) {
    <div class="rent-invoicing-order-form__module-note astral-content-width">
      {{ 'SEND_INVOICES_FORM.MODULE_STATE_TEXT' | translate }} <a routerLink="/settings">{{ 'HERE_TEXT' | translate }}</a
      >.
    </div>
  }
  @if (form) {
    <form [formGroup]="form" (ngSubmit)="onSubmit()" class="rent-invoicing-order-form astral-content-width astral-content-width--with-list-surface astral-stack-l">
      @if (!isNew) {
        <section class="astral-section-surface astral-stack-m">
          <div class="rent-invoicing-order-form__status-line">
            <h5 class="rent-invoicing-order-form__section-title">
              {{ form.controls['statusText'].value | translate }}
              <app-date-time-box [value]="form.controls['completedAt'].value"></app-date-time-box>
            </h5>
          </div>
          <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1">
            <div class="astral-grid-full">
              <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1">
                <div class="astral-grid-full">
                  <astral-input [control]="form.controls['caption']"></astral-input>
                </div>
                @if (canLoadStatistics) {
                  <div class="astral-form-adjacent-action rent-invoicing-order-form__stats-action">
                    <astral-button
                      type="button"
                      variant="secondary"
                      [labelKey]="toggleStatsText"
                      [disabled]="statsLoading"
                      (click)="toggleStats()"
                    ></astral-button>
                  </div>
                }
              </astral-layout-group>
            </div>
            @if (form.controls['errorMessage'].value) {
              <div class="astral-grid-full astral-stack-s">
                <p class="rent-invoicing-order-form__note">{{ 'RENT_INVOICING_ORDER.ERROR_INSTRUCTIONS' | translate }}</p>
                <astral-input [control]="form.controls['errorMessage']"></astral-input>
              </div>
            }
            @if (form.controls['invoiceCount'].value === 0) {
              <div class="astral-grid-full">
                <p class="rent-invoicing-order-form__note">{{ 'RENT_INVOICING_ORDER.ZERO_INVOICES_INSTRUCTIONS' | translate }}</p>
              </div>
            }
            @if (form.controls['errorMessage'].value || form.controls['invoiceCount'].value === 0) {
              <div class="astral-grid-full">
                <astral-button type="button" variant="primary" labelKey="RENT_INVOICING_ORDER.RETRY" (click)="retry()"></astral-button>
              </div>
            }
            <astral-input [control]="form.controls['createdByName']"></astral-input>
            <div class="rent-invoicing-order-form__date-box">
              <label class="rent-invoicing-order-form__date-label">{{ 'RENT_INVOICING_ORDER.ORDERED_AT' | translate }}</label>
              <app-date-time-box [value]="form.controls['createdAt'].value"></app-date-time-box>
            </div>
            @if (form.controls['invoiceCount'].value || form.controls['invoiceCount'].value === 0) {
              <astral-input [control]="form.controls['invoiceCount']"></astral-input>
            }
            @if (form.controls['invoiceCount'].value || form.controls['invoiceCount'].value === 0) {
              <astral-input [control]="form.controls['attestedInvoiceCount']"></astral-input>
            }
          </astral-layout-group>
        </section>
      }

      @if (!form.controls['leaseAgreementCaption'].value) {
        <section class="astral-section-surface astral-stack-m">
          @if (isNew) {
            <app-information-block [text]="'INVOICE.INFORMATION_TEXT.INVOICE_PERIOD' | translate"></app-information-block>
          }
          <div class="rent-invoicing-order-form__legacy-period-grid">
            <app-month-year-select
              [control]="fromControl"
              [itemsSource]="periodSelection"
              [helpText]="'SEND_INVOICES_FORM.HELP_TEXT.START_PERIOD_LABEL'"
            ></app-month-year-select>
            <app-month-year-select [control]="toControl" [itemsSource]="periodSelection"></app-month-year-select>
          </div>
        </section>
      }

      <section class="astral-section-surface astral-stack-m">
        <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1">
          @if (showCompany) {
            <astral-remote-multi-select
              [control]="settingsForm.controls['companyIds']"
              [service]="companyService"
              [defaultSearch]="'*'"
              [helpText]="'RENT_INVOICING_ORDER.HELP_TEXT.COMPANY_SELECTION'"
            ></astral-remote-multi-select>
          }
          @if (form.controls['leaseAgreementCaption'].value) {
            <astral-input [control]="form.controls['leaseAgreementCaption']"></astral-input>
          }
          @if (showProperty) {
            <astral-remote-multi-select
              [control]="settingsForm.controls['propertyIds']"
              [service]="propertyService"
              [serviceOptions]="settingsForm.controls['companyIds'].value"
              [defaultSearch]="'*'"
              [updateOnOptionsChange]="true"
            ></astral-remote-multi-select>
          }
          @if (showBuilding) {
            <astral-remote-multi-select
              [control]="settingsForm.controls['buildingIds']"
              [service]="buildingService"
              [serviceOptions]="{ companyIds: settingsForm.controls['companyIds'].value, propertyIds: settingsForm.controls['propertyIds'].value }"
              [defaultSearch]="'*'"
              [updateOnOptionsChange]="true"
            ></astral-remote-multi-select>
          }
          @if (showLeaseAgreementCategory) {
            <astral-select
              [control]="settingsForm.controls['leaseAgreementCategory']"
              [itemsSource]="leaseAgreementCategorySelection"
            ></astral-select>
          }
        </astral-layout-group>
      </section>

      @if (isNew) {
        <section class="astral-section-surface astral-stack-m">
          <div class="inforows-header">
            <h5 class="rent-invoicing-order-form__section-title">
              {{ 'RENT_INVOICING_ORDER.ADDITIONAL_INFORMATION_ROWS' | translate }}
            </h5>
            <astral-popover [helpText]="'INVOICE.HELP_TEXT.ADD_INVOICE_ROW_TEXT'"></astral-popover>
          </div>

          <div class="rent-invoicing-order-form__info-rows">
            @for (textControl of $any(textControls.controls); track textControl; let first = $first) {
              <div class="rent-invoicing-order-form__info-row" [class.rent-invoicing-order-form__info-row--single]="first">
                <astral-input [control]="textControl"></astral-input>
                @if (!first) {
                  <div class="astral-form-adjacent-action">
                    <astral-button type="button" variant="secondary" icon="trash" labelKey="DELETE_BTN" (click)="deleteTextRow(textControl)"></astral-button>
                  </div>
                }
              </div>
            }
          </div>

          <div class="rent-invoicing-order-form__add-info-row-action">
            <astral-button type="button" variant="primary" size="small" icon="plus" labelKey="ADD_BTN" (click)="addTextRow()"></astral-button>
          </div>

          <div class="rent-invoicing-order-form__file-upload">
            <app-file-upload
              [forms]="appendixesControls"
              [text]="'COMMON.ATTACH_PDF_FILE'"
              icon="pdf"
              buttonSize="small"
              [allowedMimeTypes]="mimeTypes"
              buttonVariant="primary"
            ></app-file-upload>
          </div>
        </section>
      }

      @if (!isNew) {
        @if (textControls.length) {
          <section class="astral-section-surface astral-stack-s">
            <h5 class="rent-invoicing-order-form__section-title">{{ 'RENT_INVOICING_ORDER.ADDITIONAL_INFORMATION_ROWS' | translate }}</h5>
            @for (textControl of $any(textControls.controls); track textControl) {
              <p class="rent-invoicing-order-form__paragraph">{{ textControl.value }}</p>
            }
          </section>
        }

        @if (appendixesControls.length) {
          <section class="astral-section-surface astral-stack-s">
            <h5 class="rent-invoicing-order-form__section-title">{{ 'COMMON.ATTACHED_FILES' | translate }}</h5>
            @for (fileControl of $any(appendixesControls.controls); track fileControl) {
              <p class="rent-invoicing-order-form__paragraph">{{ fileControl.value.fileName }}</p>
            }
          </section>
        }

        @if (statsLoading) {
          <app-information-block [text]="'COMMON.LOADING_MSG'"></app-information-block>
        }

        @if (statsEnabled && hasStatistics) {
          <section class="astral-stack-m">
            @for (model of previewDataContext; track model) {
              <div class="astral-section-surface">
                <app-invoices-overview [dataContext]="model"></app-invoices-overview>
              </div>
            }
          </section>
        }

        @if (showStatisticsEmptyState) {
          <app-information-block [text]="'RENT_INVOICING_ORDER.NO_STATISTICS'"></app-information-block>
        }

        @if (showCancelDelete) {
          <section class="astral-section-surface">
            <astral-button
              type="button"
              variant="secondary"
              icon="trash"
              labelKey="RENT_INVOICING_ORDER.CANCEL_DELETE_BTN"
              (click)="cancelDelete()"
            ></astral-button>
          </section>
        }

        @if (showInvoices) {
          <section class="astral-section-surface astral-section-surface--list-width astral-stack-m">
            <h5 class="rent-invoicing-order-form__section-title">{{ 'INVOICE.ALL_INVOICES' | translate }}</h5>
            @if (showAttestAll) {
              <p class="rent-invoicing-order-form__note">{{ 'RENT_INVOICING_ORDER.COMPLETE_DELETE_INSTRUCTIONS' | translate }}</p>
              <astral-button type="button" variant="primary" labelKey="RENT_INVOICING_ORDER.ATTEST_ALL_BTN" (click)="attestAll()"></astral-button>
            }
            <app-rent-invoicing-order-invoices [rentInvoicingOrderId]="dataContext.id"></app-rent-invoicing-order-invoices>
          </section>
        }
      }
    </form>
  }
</section>
